import { Component, OnInit } from '@angular/core';
import { OrderInboxService } from '../../service/order-inbox.service';
// Service
import { BroadcastService, ToasterType } from '@cv-invision/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
// Other
import { lastValueFrom } from 'rxjs';
// Types
import { ReasonType, ReOpenPayload } from '../../model/reason-types';


@Component({
    selector: 'cv-order-reopen-dialog',
    templateUrl: 'reopen-dialog.component.html',
    styleUrls: ['reopen-dialog.component.scss'],
})
export class ReOpenDialogComponent implements OnInit {
    public reasonTypes: ReasonType[] = [];
    public orderId;
    public reOpenForm = {
        reason: '',
        reasonType: ''
    }
    constructor(
        private inboxService: OrderInboxService,
        private broadcastService: BroadcastService,
        private dialogRef: DynamicDialogRef,
        public dialogConfig: DynamicDialogConfig,
    ) {}

    ngOnInit() {
        this.loadReasonTypes();
        if(this.dialogConfig?.data?.orderId){
            this.orderId = this.dialogConfig.data.orderId;
        }
    }

    close() {
        this.dialogRef.close();
    }


    /**
     * Returns the validity of the required form fields.
     * @returns {boolean}
     */
    isFormInvalid() {
		return !(this.reOpenForm.reason && this.reOpenForm.reasonType);
	}

    /**
     * Opens the reopen dialog and redirects on a success call.
     */
    public reOpen() {
        if(this.orderId){
            const reOpenPayload: ReOpenPayload = {
                ReOpenReasonType: this.reOpenForm.reasonType,
                Reason: this.reOpenForm.reason
            }
            this.inboxService.reOpenOrder(this.orderId, reOpenPayload).subscribe((response) => {
                if (response.isValid) {
                    this.broadcastService.broadcast({
                        name: ToasterType.SUCCESS,
                        event: {
                            message: `The Order <span class="order-id">${this.orderId} </span> was successfully reopened`,
                        },
                    });
                    this.dialogRef.close()
                }
            });
        }
    }  

    /**
     * 
     * Loads the reason types for the reopen operation
     */
    public async loadReasonTypes() {
        try {
          this.reasonTypes = await lastValueFrom(this.inboxService.getReasonTypes()); 
        } catch (err) {
            console.error(err)
        }
    }

    /**
     * Handles the reason input text change
     * @param {event}
     */
    public onReasonChange(event: any): void{
        if(event) {
            this.reOpenForm.reason = event?.value ?? '';
        }
    }

    /**
     * Handles the reason category dropdown change
     * @param {ReasonType} event 
     */
    public onReasonCategoryChange(event: ReasonType): void {
        if(event){
            this.reOpenForm.reasonType = event.key;
        }
    }
}
